<template>
  <v-list>
    <v-list-tile v-if="item.dots">
      <v-list-tile-action>
        <v-btn flat icon ripple :href="item.dots">
          <v-icon>picture_as_pdf</v-icon>
        </v-btn>
      </v-list-tile-action>

      <v-list-tile-content>
        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        <v-list-tile-sub-title>{{ item.arranger }}</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>

    <TeachTrack v-if="item.all" part="All Parts" :url="item.all"></TeachTrack>
    <TeachTrack v-if="item.bari" part="Bari" :url="item.bari"></TeachTrack>
    <TeachTrack v-if="item.bass" part="Bass" :url="item.bass"></TeachTrack>
    <TeachTrack v-if="item.lead" part="Lead" :url="item.lead"></TeachTrack>
    <TeachTrack v-if="item.tenor" part="Tenor" :url="item.tenor"></TeachTrack>

    <v-list-tile>
      <v-list-tile-action class="text-xs-right">
        <v-switch
          color="pink"
          :input-value="isAddedToFavourites"
          @change="toggleAddedToFavourites"
          label="Add to favourites"
        ></v-switch>
      </v-list-tile-action>
    </v-list-tile>
  </v-list>
</template>

<script>
import { mapGetters } from "vuex";

import TeachTrack from "./TeachTrack.vue";

export default {
  props: ["item"],

  components: {
    TeachTrack
  },

  data() {
    return {
      isFavourite: false
    };
  },

  computed: {
    ...mapGetters(["favourites"]),

    isAddedToFavourites() {
      return this.favourites.findIndex(x => x.id === this.item.id) >= 0;
    }
  },

  watch: {
    isAddedToFavourites(newValue) {
      this.isFavourite = newValue;
    }
  },

  methods: {
    toggleAddedToFavourites() {
      this.isFavourite = !this.isFavourite;

      if (this.isFavourite) {
        this.$store.commit("addToFavourites", this.item);
      } else {
        this.$store.commit("removeFromFavourites", this.item);
      }
    }
  },

  mounted() {
    this.isFavourite =
      this.favourites.findIndex(x => x.id === this.item.id) >= 0;
  }
};
</script>